/** MainLayout 下启用固定表格纵向滚动（配合 useTableScrollY、Card overflow 锁链）的路由 */
const MAIN_LAYOUT_FIXED_TABLE_SCROLL_PATHS = [
    '/medproject/projects',
    '/invitation/groups',
    '/conf/conferences',
    '/conf/conferences/labor-progress',
    '/conf/conferences/service-provider',
    '/uc/mdm/projects',
    '/uc/user/active-user',
    '/uc/users',
    '/uc/user-groups',
    '/uc/user/consultations',
    '/selection/projects',
    '/selection/cases',
    '/healthclass/FormalOrganizations',
    '/healthclass/TrialOrganizations',
    '/healthclass/CheckOrganizations',
    '/healthclass/clue',
    '/finance/laborfee/projects',
    '/dc/organization/list',
    '/dc/organization/merge-management',
    '/dc/experts',
    '/dc/experts-evaluation',
    '/healthaccount/eha/enterprises',
    '/healthaccount/eha/solutions',
    '/enterprise/staffs',
    '/enterprise/operation/log',
    '/enterprise/roles',
    '/enterprise/permissions',
    '/operation/channels',
    '/operation/channel-cates',
    '/operation/bi/channel/users',
    '/operation/bi/channel/view',
    '/operation/bi/channel/surveys',
    '/wj/surveys',
];

/** 动态路由白名单：支持参数段（如 :gid/:id），用正则匹配 pathname */
const MAIN_LAYOUT_FIXED_TABLE_SCROLL_PATTERNS = [
    // 邀请组-邀请函-邀请用户管理
    /^\/invitation\/g\/[^/]+\/invitations\/[^/]+\/users\/?$/,
    // 财务中心-劳务费-项目详情、付款批次、付款明细
    /^\/finance\/laborfee\/projects\/[^/]+\/?$/,
    /^\/finance\/laborfee\/projects\/[^/]+\/batches\/?$/,
    /^\/finance\/laborfee\/projects\/[^/]+\/batches\/[^/]+\/?$/,
];

const mainFixedTableScrollPathSet = new Set(MAIN_LAYOUT_FIXED_TABLE_SCROLL_PATHS);

export function isMainLayoutFixedTableScrollPath(pathname) {
    if (mainFixedTableScrollPathSet.has(pathname)) return true;
    return MAIN_LAYOUT_FIXED_TABLE_SCROLL_PATTERNS.some(re => re.test(pathname));
}
